import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

/**
 * Get a predicate element from store by ID
 * @param {string} id
 * @returns object | null
 */
export const useCriteriaStoreParentPredicateUuid = (id) => {
    if (!id) return null;
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const predicates = useStore(store, (s) => s.predicates);
    const target = predicates?.[id] ? { ...predicates?.[id] } : null;

    if (target?.parentPredicateId) {
        return Object.values(predicates).find(({ predicateId }) => predicateId === target?.parentPredicateId)?.uuid;
    }
};
